<template>
  <PageLayout>
    <div class="text-right pb-14">
      <span class="navy--text">Máte potíže?</span>
      <router-link to="/" class="link link-underline navy--text ml-2"
        >Pomoc</router-link
      >
    </div>

    <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-2">
      Vyberte Facebook Business Manager
    </h2>
    <p class="body-2 navy--text text--darken-1 pb-10">
      Propojte Adveroo se svým Facebook Business Managerem
    </p>

    <div class="mb-4 d-flex justify-end">
      <v-btn
        text
        small
        class="navy--text text--darken-1"
        :disabled="busy"
        @click="loadBusinesses()"
      >
        <img class="mr-2" :src="require('@/assets/ico-refresh.svg')" alt="" />
        Aktualizovat
      </v-btn>
    </div>

    <!--    <ui-promise-state :state="businesses$">-->
    <!--      <template #pending>-->
    <!--        <v-skeleton-loader-->
    <!--          v-for="i in 3"-->
    <!--          :key="i"-->
    <!--          class="mb-2"-->
    <!--          type="list-item-avatar"-->
    <!--        />-->
    <!--      </template>-->
    <!--      <template #success="{ value: businesses }">-->
    <div
      :class="[
        'check-card white rounded shadow shadow--hover px-4 py-4 my-4 d-flex align-center cursor-pointer',
        {
          'check-card--active': businessId === byz.id,
        },
      ]"
      v-for="byz in businesses"
      :key="byz.id"
      @click="businessId = byz.id"
    >
      <div class="mr-4">
        <v-icon class="grey--text">mdi-card-account-details-outline</v-icon>
      </div>
      <div>
        <div class="font-weight-medium">{{ byz.name }}</div>
        <div class="body-1 grey--text">{{ byz.id }}</div>
      </div>
    </div>
    <!--      </template>-->
    <!--    </ui-promise-state>-->

    <div class="d-flex justify-center mt-12">
      <v-btn
        color="facebook"
        dark
        href="https://business.facebook.com/"
        target="_blank"
        rel="noreferrer noopener"
      >
        <v-icon left>mdi-facebook</v-icon> Vytvořit Business Manager
      </v-btn>
    </div>

    <template #footer>
      <v-row>
        <v-col class="text-right">
          <v-btn
            color="primary"
            class="c-btn"
            min-width="186"
            :disabled="!isValid()"
            @click="goNext"
          >
            Pokračovat
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/onboard/PageLayout.vue"

const NEXT_ROUTE = "/onboard/connect/ad-account"

export default {
  name: "BusinessManager",
  components: {
    PageLayout,
  },
  computed: {
    ...get("accounts", ["businesses", "busy"]),
    ...sync("accounts", ["businessId"]),
  },
  methods: {
    ...call("accounts", ["loadBusinesses"]),
    isValid() {
      return !!this.businessId
    },
    goNext() {
      this.$router.push(NEXT_ROUTE)
    },
  },
  mounted() {
    this.loadBusinesses()
  },
}
</script>
